<template>
  <Report
    :report-id="reportId"
    title="Escalation Trend"
    tooltip-text="A trend showing the proportion of users who completed a flow in which they were handed over to a human"
    class="chart-container"
    :dataEmpty="isDataEmpty"
    :loadedData="isDataLoaded"
    :loadingError="loadingError"
  >
    <template #header-addons>
      <span class="button" :class="{ 'is-static': showLineChart }" @click="switchLineChart()">
        <font-awesome-icon icon="chart-line"></font-awesome-icon>
      </span>
      <span
        class="button percent-button"
        :class="{ 'is-static': showPercentageBarChart }"
        @click="switchStackedChart()"
      >
        <font-awesome-icon icon="percent"></font-awesome-icon>
      </span>
    </template>

    <template #chart>
      <LineChart
        :reportId="reportId"
        class="chart"
        v-if="showLineChart"
        :data="data"
        :fill="true"
        :seriesOrder="[{ name: 'HandedOver', displayName: 'Escalated' }]"
      />
      <PercentageBarChart
        :reportId="reportId"
        class="chart"
        v-if="showPercentageBarChart"
        :data="data"
        :seriesOrder="[{ name: 'HandedOver', displayName: 'Escalated' }]"
        series-to-compare-to="Completed"
      />
    </template>
  </Report>
</template>

<script lang="ts" setup>
import PercentageBarChart from '../chartjs/PercentageBarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import { ReportType } from '../../models/reportType';
import { useFlowReport } from '@/features/reports/components/flows/useFlowReport';
import { watch } from 'vue';
import Report from '@/features/reports/components/Report.vue';

const emit = defineEmits<{
  (e: 'loaded'): void;
}>();

const {
  reportId,
  isDataLoaded,
  isDataEmpty,
  loadingError,
  data,
  showLineChart,
  showPercentageBarChart,
  switchLineChart,
  switchStackedChart,
} = useFlowReport(ReportType.FLOW_ESCALATIONS);

watch([isDataLoaded, loadingError], () => {
  if (isDataLoaded.value) emit('loaded');
});
</script>

<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;

.header {
  .title-container {
    .icon {
      font-size: 1.1rem;
      height: 1rem;
    }
  }
}

.error-overlay {
  background: #f9f9f9;
}
</style>
